import {
  Backdrop,
  Box,
  CircularProgress,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
  Typography,
  Pagination,
  Stack,
  TextField,
  Button,
  Select,
  MenuItem,
} from "@mui/material";
import { useSelector } from "react-redux";
import productService from "../../../../services/productService";
import { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import useAlert from "../../../../hooks/useAlert";

const CategoryProductEditModal = ({ open, handleClose, category }) => {
  const userId = useSelector((state) => state?.auth?.user?.id);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [products, setProducts] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState("");
  const [searchTerm, setSearchTerm] = useState(null);
  const getProduct = async (currentPage) => {
    try {
      setLoading(true);
      var response = await productService.fetchSearchProducts(
        null,
        userId,
        currentPage,
        pageSize,
        searchTerm
      );
      setProducts(response?.data?.data);

      setTotalPages(Math.ceil(response?.data?.recordsTotal / pageSize) || 1);
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      setSelectedProducts([]);
      getProduct(page);
    }
  }, [open, page, searchTerm, pageSize]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleSearch = () => {
    setSearchTerm(search);
    setPage(1);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelected = products.map((product) => ({
        ...product,
        categoryId: category.id,
      }));
      setSelectedProducts(newSelected);
    } else {
      setSelectedProducts([]);
    }
  };

  const handleSelectOne = (event, product) => {
    if (event.target.checked) {
      setSelectedProducts([
        ...selectedProducts,
        {
          ...product,
          categoryId: category.id,
        },
      ]);
    } else {
      setSelectedProducts(selectedProducts.filter((p) => p.id !== product.id));
    }
  };

  const isSelected = (productId) =>
    selectedProducts.find((p) => p.id === productId) !== undefined;

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "95%", sm: "90%", md: "80%" },
    bgcolor: "background.paper",
    boxShadow: 24,
    p: { xs: 2, sm: 3, md: 4 },
    maxHeight: { xs: "90vh", sm: "80vh" },
    overflow: "auto",
    borderRadius: 2,
  };

  const { showSuccessAlertMarketpleaceBrand, showErrorAlertMarketpleaceBrand } =
    useAlert();
  const updateProductsCategory = async () => {
    try {
      setLoading(true);
      await productService.updateRangeProduct(selectedProducts);
      showSuccessAlertMarketpleaceBrand();
      setLoading(false);
    } catch {
      setLoading(false);
      showErrorAlertMarketpleaceBrand();
    }
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="category-product-modal"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            mb: 2,
            gap: { xs: 1, sm: 0 },
          }}
        >
          <Typography
            variant="h6"
            component="h2"
            sx={{ fontSize: { xs: "1.1rem", sm: "1.25rem" } }}
          >
            Kategori için Ürün Seçin
          </Typography>
          <Typography
            variant="h6"
            component="h2"
            sx={{
              fontSize: { xs: "1rem", sm: "1.25rem" },
              color: "text.secondary",
            }}
          >
            Seçilen kategori: {category?.name || ""}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
            mb: 2,
            alignItems: { xs: "stretch", sm: "center" },
          }}
        >
          <TextField
            fullWidth
            size="small"
            placeholder="Ürün ara..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyPress={handleKeyPress}
            sx={{ mb: { xs: 2, sm: 0 } }}
          />

          <Select
            size="small"
            value={pageSize}
            onChange={(e) => setPageSize(e.target.value)}
            sx={{
              minWidth: { xs: "100%", sm: "90px" },
              maxWidth: { xs: "100%", sm: "90px" },
              mb: { xs: 2, sm: 0 },
            }}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>

          <Button
            variant="contained"
            startIcon={<SearchIcon />}
            onClick={handleSearch}
            sx={{
              minWidth: { xs: "100%", sm: "120px" },
              borderRadius: 2,
              mt: { xs: 1, sm: 0 },
            }}
          >
            Ara
          </Button>
        </Box>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
            <CircularProgress color="inherit" />
          </Box>
        ) : (
          <Box
            sx={{
              overflowX: "auto",
              "& .MuiTable-root": {
                minWidth: { xs: 650, sm: "100%" },
              },
            }}
          >
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        color="primary"
                        indeterminate={
                          selectedProducts.length > 0 &&
                          selectedProducts.length < products?.length
                        }
                        checked={
                          products?.length > 0 &&
                          selectedProducts.length === products?.length
                        }
                        onChange={handleSelectAll}
                      />
                    </TableCell>
                    <TableCell>Başlık</TableCell>
                    <TableCell
                      sx={{ display: { xs: "none", sm: "table-cell" } }}
                    >
                      Stok Kodu
                    </TableCell>
                    <TableCell
                      sx={{ display: { xs: "none", md: "table-cell" } }}
                    >
                      Miktar
                    </TableCell>
                    <TableCell
                      sx={{ display: { xs: "none", md: "table-cell" } }}
                    >
                      Tedarikçi Barkodu
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {products?.map((product) => (
                    <TableRow key={product.id}>
                      <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={isSelected(product.id)}
                          onChange={(event) => handleSelectOne(event, product)}
                        />
                      </TableCell>
                      <TableCell>
                        <Stack direction="row" alignItems="center" spacing={2}>
                          {product.productImages.length > 0 && (
                            <Box
                              component="img"
                              src={product?.productImages[0]?.imageUrl}
                              alt={product?.title}
                              referrerPolicy="no-referrer"
                              sx={{
                                width: { xs: 40, sm: 50 },
                                height: { xs: 40, sm: 50 },
                                objectFit: "contain",
                              }}
                            />
                          )}
                          <Box>
                            <Typography variant="body2">
                              {product?.title || "-"}
                            </Typography>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{ display: { xs: "block", sm: "none" } }}
                            >
                              Stok Kodu: {product.stockCode}
                            </Typography>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{ display: { xs: "block", md: "none" } }}
                            >
                              Miktar: {product.quantity}
                            </Typography>
                          </Box>
                        </Stack>
                      </TableCell>
                      <TableCell
                        sx={{ display: { xs: "none", sm: "table-cell" } }}
                      >
                        {product.stockCode}
                      </TableCell>
                      <TableCell
                        sx={{ display: { xs: "none", md: "table-cell" } }}
                      >
                        {product.quantity}
                      </TableCell>
                      <TableCell
                        sx={{ display: { xs: "none", md: "table-cell" } }}
                      >
                        {product.supplierBarcode}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box
              sx={{
                mt: 2,
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "space-between",
                alignItems: "center",
                gap: { xs: 2, sm: 0 },
              }}
            >
              <Box sx={{ width: { xs: "100%", sm: "120px" } }} />
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                color="primary"
                showFirstButton
                showLastButton
                siblingCount={1}
                boundaryCount={1}
                size={window.innerWidth < 600 ? "small" : "large"}
                sx={{
                  "& .MuiPagination-ul": {
                    justifyContent: "center",
                  },
                }}
              />
              <Button
                variant="contained"
                onClick={updateProductsCategory}
                disabled={selectedProducts.length == 0}
                sx={{
                  width: { xs: "100%", sm: "120px" },
                  borderRadius: 2,
                }}
              >
                Kaydet
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default CategoryProductEditModal;
